export default function () {
  //activate Onetrust
  ;(function () {
    function OptanonWrapper() {}
    console.log(OptanonWrapper)
  })()
  //}
}
